import * as React from 'react';

export class AnypointCustomMetricsConnectorSvg extends React.Component<{}> {

  render() {
    return (
      <svg width="64px" height="64px" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <title>custom-metrics</title>
        <desc>Created with Sketch.</desc>
        <g id="custom-metrics" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Group-5" transform="translate(6.000000, 2.000000)">
            <polygon
              id="Fill-1"
              fill="#087299"
              points="47.3693684 57.8109474 53.6851579 53.3898947 53.6851579 29.6867368 47.3693684 25.2625263"
            />
            <polygon
              id="Fill-2"
              fill="#00A3E0"
              points="31.5786316 15.0230526 31.5786316 57.8093684 37.8944211 53.3883158 37.8944211 19.2641053 31.8375789 15.0230526"
            />
            <polygon
              id="Fill-3"
              fill="#00A3E0"
              points="15.7907368 30.8137895 15.7907368 58.7611579 22.1065263 54.3369474 22.1065263 35.0548421 16.0496842 30.8137895"
            />
            <polygon
              id="Fill-4"
              fill="#087299"
              points="0 -0.000315789474 0 59.0712632 6.31578947 54.6502105 6.31578947 4.42073684"
            />
          </g>
        </g>
      </svg>
    )
  }
}
